export type ROULETTE_CURRENCY_TYPE = {
    sign: string,
    name: string
}
declare var ROULETTE_CURRENCIES: Array<ROULETTE_CURRENCY_TYPE>;
export default ROULETTE_CURRENCIES;
